import React from 'react';

import { JobType, StudyReportJob } from 'interfaces/job';
import JobReportTab from './JobReportTab';

interface Props {
  pageSize?: number;
  selectedStudyId?: string;
}

const StudyReport: React.FunctionComponent<React.PropsWithChildren<Props>> = ({ pageSize = 10, selectedStudyId }) => {
  return (
    <JobReportTab<StudyReportJob>
      tabTitle="Study Report"
      jobType={JobType.StudyReport}
      pageSize={pageSize}
      selectedStudyId={selectedStudyId}
    />
  );
};

export default StudyReport;
